import HorsesTableItem from './HorsesTableItem';

export default HorsesTableItem;
